class UserRole {
    name;
    website_id;
}

export default UserRole;